/**
 * 드롭다운과 같은 컴포넌트에서 사용하는 열림/닫힘 화살표 아이콘
 */
import React from 'react'
import classNames from 'classnames'
export var ODArrow = function (props) {
  var open = props.open
  var caretClassName = classNames(
    { 'rotate-180': open, 'rotate-0': !open },
    'inline w-4 h-4 mt-1 ml-1 transition-transform duration-200 transform md:-mt-1'
  )
  return React.createElement(
    'svg',
    { fill: 'currentColor', viewBox: '0 0 20 20', className: caretClassName },
    React.createElement('path', {
      fillRule: 'evenodd',
      d:
        'M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z',
      clipRule: 'evenodd',
    })
  )
}
//# sourceMappingURL=ODArrow.js.map
